export default __webpack_public_path__ + "static/media/858.16c6f8b6.png";